import { useQuery } from '@tanstack/react-query';
import { HttpNOTES } from '../api/httpNOTES';

export const useNOTESParametros = (idOperacion: number) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['notes-parametros', idOperacion],
    queryFn: () => HttpNOTES.getParametros(idOperacion),
    enabled: !!idOperacion,
  });

  return {
    parametros: data,
    isLoading,
    isError,
    error
  };
};